import { render } from "./ZdfFooter.vue?vue&type=template&id=e65ff4ec"
import script from "./ZdfFooter.vue?vue&type=script&lang=js"
export * from "./ZdfFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__